module.exports = __webpack_public_path__ + "img/inspiration_02.be66524.jpg";